import './index.scss'
$("header .nav li").eq(3).addClass("active");